import { store } from "../../store/index";
import { getAll } from "../../store/actions/visual/FarmActions";

/**
 * List Course
 */
export const listFarms = async (filter) => {
  const result = await store.dispatch(getAll(filter));
  if (result) {
    return result.payload.result;
  }
  return null;
};
